module.exports = __webpack_public_path__ + "static/img/img_app_doc.4f67fdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/renew_pc/img_app_doc.png
// module id = gtXs
// module chunks = 0